/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Add_UserInputs */

const en_users_add_user = /** @type {(inputs: Users_Add_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add user`)
};

const pt_br2_users_add_user = /** @type {(inputs: Users_Add_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar usuário`)
};

/**
* | output |
* | --- |
* | "Add user" |
*
* @param {Users_Add_UserInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_add_user = /** @type {((inputs?: Users_Add_UserInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Add_UserInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_add_user(inputs)
	return pt_br2_users_add_user(inputs)
});